"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Version2ScheduledTokenRelease = exports.Version2Params = exports.Version2Minter = exports.ScheduledTokenRelease = exports.Params = exports.Minter = void 0;
var _helpers = require("../../../../helpers");
var _m0 = _interopRequireWildcard(require("protobufjs/minimal"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function createBaseMinter() {
  return {
    startDate: "",
    endDate: "",
    denom: "",
    totalMintAmount: _helpers.Long.UZERO,
    remainingMintAmount: _helpers.Long.UZERO,
    lastMintAmount: _helpers.Long.UZERO,
    lastMintDate: "",
    lastMintHeight: _helpers.Long.UZERO
  };
}
var Minter = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.startDate !== "") {
      writer.uint32(10).string(message.startDate);
    }
    if (message.endDate !== "") {
      writer.uint32(18).string(message.endDate);
    }
    if (message.denom !== "") {
      writer.uint32(26).string(message.denom);
    }
    if (!message.totalMintAmount.isZero()) {
      writer.uint32(32).uint64(message.totalMintAmount);
    }
    if (!message.remainingMintAmount.isZero()) {
      writer.uint32(40).uint64(message.remainingMintAmount);
    }
    if (!message.lastMintAmount.isZero()) {
      writer.uint32(48).uint64(message.lastMintAmount);
    }
    if (message.lastMintDate !== "") {
      writer.uint32(58).string(message.lastMintDate);
    }
    if (!message.lastMintHeight.isZero()) {
      writer.uint32(64).uint64(message.lastMintHeight);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseMinter();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.startDate = reader.string();
          break;
        case 2:
          message.endDate = reader.string();
          break;
        case 3:
          message.denom = reader.string();
          break;
        case 4:
          message.totalMintAmount = reader.uint64();
          break;
        case 5:
          message.remainingMintAmount = reader.uint64();
          break;
        case 6:
          message.lastMintAmount = reader.uint64();
          break;
        case 7:
          message.lastMintDate = reader.string();
          break;
        case 8:
          message.lastMintHeight = reader.uint64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial: function fromPartial(object) {
    var _object$startDate, _object$endDate, _object$denom, _object$lastMintDate;
    var message = createBaseMinter();
    message.startDate = (_object$startDate = object.startDate) !== null && _object$startDate !== void 0 ? _object$startDate : "";
    message.endDate = (_object$endDate = object.endDate) !== null && _object$endDate !== void 0 ? _object$endDate : "";
    message.denom = (_object$denom = object.denom) !== null && _object$denom !== void 0 ? _object$denom : "";
    message.totalMintAmount = object.totalMintAmount !== undefined && object.totalMintAmount !== null ? _helpers.Long.fromValue(object.totalMintAmount) : _helpers.Long.UZERO;
    message.remainingMintAmount = object.remainingMintAmount !== undefined && object.remainingMintAmount !== null ? _helpers.Long.fromValue(object.remainingMintAmount) : _helpers.Long.UZERO;
    message.lastMintAmount = object.lastMintAmount !== undefined && object.lastMintAmount !== null ? _helpers.Long.fromValue(object.lastMintAmount) : _helpers.Long.UZERO;
    message.lastMintDate = (_object$lastMintDate = object.lastMintDate) !== null && _object$lastMintDate !== void 0 ? _object$lastMintDate : "";
    message.lastMintHeight = object.lastMintHeight !== undefined && object.lastMintHeight !== null ? _helpers.Long.fromValue(object.lastMintHeight) : _helpers.Long.UZERO;
    return message;
  }
};
exports.Minter = Minter;
function createBaseScheduledTokenRelease() {
  return {
    startDate: "",
    endDate: "",
    tokenReleaseAmount: _helpers.Long.UZERO
  };
}
var ScheduledTokenRelease = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.startDate !== "") {
      writer.uint32(10).string(message.startDate);
    }
    if (message.endDate !== "") {
      writer.uint32(18).string(message.endDate);
    }
    if (!message.tokenReleaseAmount.isZero()) {
      writer.uint32(24).uint64(message.tokenReleaseAmount);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseScheduledTokenRelease();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.startDate = reader.string();
          break;
        case 2:
          message.endDate = reader.string();
          break;
        case 3:
          message.tokenReleaseAmount = reader.uint64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial: function fromPartial(object) {
    var _object$startDate2, _object$endDate2;
    var message = createBaseScheduledTokenRelease();
    message.startDate = (_object$startDate2 = object.startDate) !== null && _object$startDate2 !== void 0 ? _object$startDate2 : "";
    message.endDate = (_object$endDate2 = object.endDate) !== null && _object$endDate2 !== void 0 ? _object$endDate2 : "";
    message.tokenReleaseAmount = object.tokenReleaseAmount !== undefined && object.tokenReleaseAmount !== null ? _helpers.Long.fromValue(object.tokenReleaseAmount) : _helpers.Long.UZERO;
    return message;
  }
};
exports.ScheduledTokenRelease = ScheduledTokenRelease;
function createBaseParams() {
  return {
    mintDenom: "",
    tokenReleaseSchedule: []
  };
}
var Params = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.mintDenom !== "") {
      writer.uint32(10).string(message.mintDenom);
    }
    var _iterator = _createForOfIteratorHelper(message.tokenReleaseSchedule),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var v = _step.value;
        ScheduledTokenRelease.encode(v, writer.uint32(18).fork()).ldelim();
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseParams();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mintDenom = reader.string();
          break;
        case 2:
          message.tokenReleaseSchedule.push(ScheduledTokenRelease.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial: function fromPartial(object) {
    var _object$mintDenom, _object$tokenReleaseS;
    var message = createBaseParams();
    message.mintDenom = (_object$mintDenom = object.mintDenom) !== null && _object$mintDenom !== void 0 ? _object$mintDenom : "";
    message.tokenReleaseSchedule = ((_object$tokenReleaseS = object.tokenReleaseSchedule) === null || _object$tokenReleaseS === void 0 ? void 0 : _object$tokenReleaseS.map(function (e) {
      return ScheduledTokenRelease.fromPartial(e);
    })) || [];
    return message;
  }
};
exports.Params = Params;
function createBaseVersion2Minter() {
  return {
    lastMintAmount: "",
    lastMintDate: "",
    lastMintHeight: _helpers.Long.ZERO,
    denom: ""
  };
}
var Version2Minter = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.lastMintAmount !== "") {
      writer.uint32(10).string(message.lastMintAmount);
    }
    if (message.lastMintDate !== "") {
      writer.uint32(18).string(message.lastMintDate);
    }
    if (!message.lastMintHeight.isZero()) {
      writer.uint32(24).int64(message.lastMintHeight);
    }
    if (message.denom !== "") {
      writer.uint32(34).string(message.denom);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVersion2Minter();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.lastMintAmount = reader.string();
          break;
        case 2:
          message.lastMintDate = reader.string();
          break;
        case 3:
          message.lastMintHeight = reader.int64();
          break;
        case 4:
          message.denom = reader.string();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial: function fromPartial(object) {
    var _object$lastMintAmoun, _object$lastMintDate2, _object$denom2;
    var message = createBaseVersion2Minter();
    message.lastMintAmount = (_object$lastMintAmoun = object.lastMintAmount) !== null && _object$lastMintAmoun !== void 0 ? _object$lastMintAmoun : "";
    message.lastMintDate = (_object$lastMintDate2 = object.lastMintDate) !== null && _object$lastMintDate2 !== void 0 ? _object$lastMintDate2 : "";
    message.lastMintHeight = object.lastMintHeight !== undefined && object.lastMintHeight !== null ? _helpers.Long.fromValue(object.lastMintHeight) : _helpers.Long.ZERO;
    message.denom = (_object$denom2 = object.denom) !== null && _object$denom2 !== void 0 ? _object$denom2 : "";
    return message;
  }
};
exports.Version2Minter = Version2Minter;
function createBaseVersion2ScheduledTokenRelease() {
  return {
    date: "",
    tokenReleaseAmount: _helpers.Long.ZERO
  };
}
var Version2ScheduledTokenRelease = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.date !== "") {
      writer.uint32(10).string(message.date);
    }
    if (!message.tokenReleaseAmount.isZero()) {
      writer.uint32(16).int64(message.tokenReleaseAmount);
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVersion2ScheduledTokenRelease();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.date = reader.string();
          break;
        case 2:
          message.tokenReleaseAmount = reader.int64();
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial: function fromPartial(object) {
    var _object$date;
    var message = createBaseVersion2ScheduledTokenRelease();
    message.date = (_object$date = object.date) !== null && _object$date !== void 0 ? _object$date : "";
    message.tokenReleaseAmount = object.tokenReleaseAmount !== undefined && object.tokenReleaseAmount !== null ? _helpers.Long.fromValue(object.tokenReleaseAmount) : _helpers.Long.ZERO;
    return message;
  }
};
exports.Version2ScheduledTokenRelease = Version2ScheduledTokenRelease;
function createBaseVersion2Params() {
  return {
    mintDenom: "",
    tokenReleaseSchedule: []
  };
}
var Version2Params = {
  encode: function encode(message) {
    var writer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _m0.Writer.create();
    if (message.mintDenom !== "") {
      writer.uint32(10).string(message.mintDenom);
    }
    var _iterator2 = _createForOfIteratorHelper(message.tokenReleaseSchedule),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var v = _step2.value;
        Version2ScheduledTokenRelease.encode(v, writer.uint32(18).fork()).ldelim();
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
    return writer;
  },
  decode: function decode(input, length) {
    var reader = input instanceof _m0.Reader ? input : new _m0.Reader(input);
    var end = length === undefined ? reader.len : reader.pos + length;
    var message = createBaseVersion2Params();
    while (reader.pos < end) {
      var tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          message.mintDenom = reader.string();
          break;
        case 2:
          message.tokenReleaseSchedule.push(Version2ScheduledTokenRelease.decode(reader, reader.uint32()));
          break;
        default:
          reader.skipType(tag & 7);
          break;
      }
    }
    return message;
  },
  fromPartial: function fromPartial(object) {
    var _object$mintDenom2, _object$tokenReleaseS2;
    var message = createBaseVersion2Params();
    message.mintDenom = (_object$mintDenom2 = object.mintDenom) !== null && _object$mintDenom2 !== void 0 ? _object$mintDenom2 : "";
    message.tokenReleaseSchedule = ((_object$tokenReleaseS2 = object.tokenReleaseSchedule) === null || _object$tokenReleaseS2 === void 0 ? void 0 : _object$tokenReleaseS2.map(function (e) {
      return Version2ScheduledTokenRelease.fromPartial(e);
    })) || [];
    return message;
  }
};
exports.Version2Params = Version2Params;